import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNewFolderLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M9.51938 3C10.1269 3 10.7016 3.27618 11.0811 3.75061L12.4806 5.5H20C21.1046 5.5 22 6.39543 22 7.5V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V5C2 3.89543 2.89543 3 4 3H9.51938ZM9.51938 5H4V19H20V7.5H12.4806C11.8731 7.5 11.2984 7.22382 10.9189 6.74939L9.51938 5ZM12 9C12.5523 9 13 9.44772 13 10V12H15C15.5523 12 16 12.4477 16 13C16 13.5523 15.5523 14 15 14H13V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V14H9C8.44772 14 8 13.5523 8 13C8 12.4477 8.44772 12 9 12H11V10C11 9.44772 11.4477 9 12 9Z" })
});
export default SvgNewFolderLine;
